import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Form = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.57475 4.69627C5.23686 4.69627 4.96294 4.97018 4.96294 5.30807C4.96294 5.64596 5.23686 5.91988 5.57475 5.91988H10.425C10.7629 5.91988 11.0368 5.64596 11.0368 5.30807C11.0368 4.97018 10.7629 4.69627 10.425 4.69627H5.57475Z"
        fill="currentColor"
      />
      <path
        d="M4.96294 8.00001C4.96294 7.66212 5.23686 7.38821 5.57475 7.38821H10.425C10.7629 7.38821 11.0368 7.66212 11.0368 8.00001C11.0368 8.3379 10.7629 8.61182 10.425 8.61182H5.57475C5.23686 8.61182 4.96294 8.3379 4.96294 8.00001Z"
        fill="currentColor"
      />
      <path
        d="M5.57475 10.0801C5.23686 10.0801 4.96294 10.3541 4.96294 10.692C4.96294 11.0298 5.23686 11.3038 5.57475 11.3038H10.425C10.7629 11.3038 11.0368 11.0298 11.0368 10.692C11.0368 10.3541 10.7629 10.0801 10.425 10.0801H5.57475Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83843 2C3.95992 2 3.24774 2.71218 3.24774 3.59069V12.4093C3.24774 13.2878 3.95992 14 4.83843 14H11.1615C12.04 14 12.7522 13.2878 12.7522 12.4093V3.59069C12.7522 2.71218 12.04 2 11.1615 2H4.83843ZM4.47135 3.59069C4.47135 3.38796 4.6357 3.22361 4.83843 3.22361H11.1615C11.3643 3.22361 11.5286 3.38796 11.5286 3.59069V12.4093C11.5286 12.612 11.3643 12.7764 11.1615 12.7764H4.83843C4.6357 12.7764 4.47135 12.612 4.47135 12.4093V3.59069Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Form;
